import * as types from '../mutation-types';
import ConversationAPI from '../../api/conversations';

// v114 (Kairo 08/07): cache com validade pras etiquetas da conversa. O
// ConversationBox refazia GET /conversations/:id/labels a CADA clique de
// conversa (4.727 chamadas/15min pra 692 conversas = 85% repetidas — 36% de
// todo o trafego do Puma). Agora: se buscou ha menos de CACHE_TTL_MS e ja tem
// registro, usa o que esta na memoria. Mudancas de outros agentes/IA chegam
// pelo websocket (conversation.updated -> setConversationLabel), que atualiza
// o cache na hora — tempo real preservado.
const CACHE_TTL_MS = 2 * 60 * 1000;
const lastFetchedAt = {};

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isError: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getConversationLabels: $state => id => {
    return $state.records[Number(id)] || [];
  },
};

export const actions = {
  get: async ({ commit, state: $state }, conversationId) => {
    // v114: cache-hit — registro existe e foi buscado/atualizado ha pouco.
    const fetchedAt = lastFetchedAt[Number(conversationId)];
    const hasRecord =
      Object.prototype.hasOwnProperty.call($state.records, Number(conversationId)) ||
      Object.prototype.hasOwnProperty.call($state.records, conversationId);
    if (fetchedAt && hasRecord && Date.now() - fetchedAt < CACHE_TTL_MS) {
      return;
    }
    commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await ConversationAPI.getLabels(conversationId);
      commit(types.default.SET_CONVERSATION_LABELS, {
        id: conversationId,
        data: response.data.payload,
      });
      lastFetchedAt[Number(conversationId)] = Date.now();
      commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  update: async ({ commit }, { conversationId, labels }) => {
    commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
      isUpdating: true,
    });
    try {
      const response = await ConversationAPI.updateLabels(
        conversationId,
        labels
      );
      commit(types.default.SET_CONVERSATION_LABELS, {
        id: conversationId,
        data: response.data.payload,
      });
      lastFetchedAt[Number(conversationId)] = Date.now();
      commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
        isUpdating: false,
        isError: false,
      });
    } catch (error) {
      commit(types.default.SET_CONVERSATION_LABELS_UI_FLAG, {
        isUpdating: false,
        isError: true,
      });
    }
  },
  setBulkConversationLabels({ commit }, conversations) {
    commit(types.default.SET_BULK_CONVERSATION_LABELS, conversations);
  },
  setConversationLabel({ commit }, { id, data }) {
    // v114: tambem chamado pelo websocket (conversation.updated) — dado fresco
    // vindo do servidor, renova a validade do cache.
    commit(types.default.SET_CONVERSATION_LABELS, { id, data });
    lastFetchedAt[Number(id)] = Date.now();
  },
};

export const mutations = {
  [types.default.SET_CONVERSATION_LABELS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_CONVERSATION_LABELS]: ($state, { id, data }) => {
    $state.records = { ...$state.records, [id]: data };
  },
  [types.default.SET_BULK_CONVERSATION_LABELS]: ($state, conversations) => {
    const updatedRecords = { ...$state.records };
    conversations.forEach(conversation => {
      updatedRecords[conversation.id] = conversation.labels;
    });

    $state.records = updatedRecords;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
